import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const cleanup = createAction(types.CLEANUP);
